// START IMPORTS
import { renderMarkdown } from '@a2ui/markdown-it';
import { A2uiSurface, MarkdownContext, basicCatalog } from '@a2ui/react/v0_9';
import { MessageProcessor, A2uiMessage } from '@a2ui/web_core/v0_9';
import { useMemo } from 'react';

import { deepSearchCatalog } from './A2uiCatalog';

// END IMPORTS

// START INTERFACES_AND_TYPES
interface A2uiReportRendererProps {
  messages: A2uiMessage[];
}
// END INTERFACES_AND_TYPES

export const A2uiReportRenderer = ({ messages }: A2uiReportRendererProps) => {
  // START DERIVED_DATA_AND_UTILS
  const surfaces = useMemo(() => {
    const next = new MessageProcessor([basicCatalog, deepSearchCatalog]);
    next.processMessages(messages);
    return Array.from(next.model.surfacesMap.values());
  }, [messages]);
  // END DERIVED_DATA_AND_UTILS

  // START EARLY_RETURNS
  if (surfaces.length === 0) {
    return null;
  }
  // END EARLY_RETURNS

  // START RENDER
  return (
    <MarkdownContext.Provider value={renderMarkdown}>
      {surfaces.map((surface) => (
        <A2uiSurface key={surface.id} surface={surface} />
      ))}
    </MarkdownContext.Provider>
  );
  // END RENDER
};
